import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLeaguesService } from '../../../../services/leagues/api/api-leagues.service';
import { AlertsService } from '../../../../services/alerts.service';
import { LeagueReward } from '../../../../models/leagues/league-reward.model';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-league-reward-edit-modal',
  templateUrl: './league-reward-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LeagueRewardEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  rewardId: number = 0;
  rank: number = 1;
  currencyType: number = 0;
  currencyQuantity: number = 0;
  currencyTicketCost: number = 0;

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiLeaguesService: ApiLeaguesService, private alertsService: AlertsService) {}

  show(reward: LeagueReward, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.rewardId = reward.rewardId;
    this.rank = reward.rank;
    this.currencyType = reward.currencyType;
    this.currencyQuantity = reward.currencyQuantity;
    this.currencyTicketCost = reward.currencyTicketCost;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLeaguesService.editLeagueReward(this.rewardId, this.rank, this.currencyType, this.currencyQuantity, this.currencyTicketCost).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Reward updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating reward : ' + error);
      }
    );
  }
}
